import { LoaderCircleIcon } from 'lucide-react'
import { useEffect, useState } from 'react'
import { Outlet } from 'react-router'

import { AllowancesProvider } from 'apps/employer_renewals/providers/AllowancesProvider'
import { QuoteResultsProvider, useQuoteResults } from 'apps/employer_renewals/providers/QuoteResultsProvider'
import { Banner } from 'slab'

import PageContainer from './PageContainer'

export function AllowancesLayout () {
  const { isProcessing, isError } = useQuoteResults()
  const [loadingMessage, setLoadingMessage] = useState('')

  useEffect(() => {
    if (!isProcessing) {
      return
    }

    const timeout1 = setTimeout(() => {
      setLoadingMessage('Sit tight! This may take a few seconds...')
    }, 2000)

    const timeout2 = setTimeout(() => {
      setLoadingMessage('We\'re still crunching numbers, almost there!')
    }, 5000)

    return () => {
      clearTimeout(timeout1)
      clearTimeout(timeout2)
    }
  }, [isProcessing])

  if (isProcessing) {
    return (
      <PageContainer verticallyCentered>
        <div className='flex flex-col items-center justify-center gap-2'>
          <LoaderCircleIcon size={24} className='animate-spin text-gray-500' />
          <p className='heading-sm'>Calculating the best strategy for you and your team</p>
          <p className='body animate-fade-in'>{loadingMessage}</p>
        </div>
      </PageContainer>
    )
  }

  if (isError) {
    return (
      <PageContainer verticallyCentered>
        <Banner type='critical' title='Error loading allowances'>
          Something went wrong. Please try reloading the page. If the problem persists, please contact support.
        </Banner>
      </PageContainer>
    )
  }

  return (
    <Outlet />
  )
}

export default () => (
  <QuoteResultsProvider>
    <AllowancesProvider>
      <AllowancesLayout />
    </AllowancesProvider>
  </QuoteResultsProvider>
)
